module.exports = __webpack_public_path__ + "static/fs-img-4-137db6005cd95b9e6daa9a8175f0a7b6.png";